import React from 'react';

export default function TokenizedLogo({ className, size = 'medium' }) {
  return (
    <svg
      className={className}
      width={size === 'small' ? 16 : size === 'medium' ? 24 : 28}
      height={size === 'small' ? 16 : size === 'medium' ? 24 : 28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" fill="url(#paint0_linear_2_2857)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5ZM18.5 8V11.25H15.5V21H12.5V11.25H9.5V8H18.5Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2_2857"
          x1="14"
          y1="0"
          x2="14"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#31496D" />
          <stop offset="1" stopColor="#20324C" />
        </linearGradient>
      </defs>
    </svg>
  );
}
